export function Divider() {
  return <hr className="border-gray-200" />;
}
